<template>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <div class="card-header-2">
                        <h5>Product Comment Information</h5>
                    </div>

                    <v-form class="theme-form theme-form-2 mega-form" ref="formProductComment" >
                        <div class="row">
                            <div class="mb-4 row align-items-center">
                                <label class="form-label-title col-sm-2 mb-0">Comment ID</label>
                                <div class="col-sm-10">
                                    <v-text-field :model-value="commentData.id || ''" readonly></v-text-field>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="mb-4 row align-items-center">
                                <label class="form-label-title col-sm-2 mb-0">User</label>
                                <div class="col-sm-10">
                                    <v-text-field :model-value="commentData.user?.name || commentData.user_name || '-'" readonly></v-text-field>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="mb-4 row align-items-center">
                                <label class="form-label-title col-sm-2 mb-0">Product</label>
                                <div class="col-sm-10">
                                    <v-text-field :model-value="productName" readonly></v-text-field>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="mb-4 row align-items-center">
                                <label class="form-label-title col-sm-2 mb-0">Status</label>
                                <div class="col-sm-10">
                                    <article-comment-status-component
                                        :items="statusOptions"
                                        :selected="selectedStatus"
                                        :selectedItem="selectedStatusItem"
                                        :saving="statusSaving"
                                        :saved="statusSaved"
                                        :showSaveButton="true"
                                        @update:selected="changeCommentStatus"
                                        @save:selected="changeCommentStatus"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="mb-4 row align-items-center">
                                <label class="form-label-title col-sm-2 mb-0">Assessment</label>
                                <div class="col-sm-10">
                                    <v-rating
                                        :model-value="commentData.assessment || 0"
                                        color="orange-darken-2"
                                        density="compact"
                                        readonly
                                    ></v-rating>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="mb-4 row align-items-center">
                                <label class="form-label-title col-sm-2 mb-0">Created at</label>
                                <div class="col-sm-10">
                                    <v-text-field v-model="editableCreatedAt" type="datetime-local"></v-text-field>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="mb-4 row align-items-center">
                                <label class="form-label-title col-sm-2 mb-0">Updated at</label>
                                <div class="col-sm-10">
                                    <v-text-field
                                        v-model="editableUpdatedAt"
                                        type="datetime-local"
                                        hint="Esta es la fecha que se muestra en la reseña en la tienda online"
                                        persistent-hint
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="mb-4 row align-items-center">
                                <label class="form-label-title col-sm-2 mb-0"></label>
                                <div class="col-sm-10">
                                    <v-btn
                                        color="primary"
                                        prepend-icon="mdi-content-save"
                                        :loading="savingDates"
                                        @click="saveDates"
                                    >
                                        Modificar fechas
                                    </v-btn>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="mb-4 row align-items-center">
                                <label class="form-label-title col-sm-2 mb-0">Comment</label>
                                <div class="col-sm-10">
                                    <v-textarea v-model="editableComment" rows="6"></v-textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="mb-4 row align-items-center">
                                <label class="form-label-title col-sm-2 mb-0">Quick actions</label>
                                <div class="col-sm-10 d-flex" style="gap: 10px;">
                                    <v-btn
                                        color="primary"
                                        prepend-icon="mdi-content-save"
                                        :loading="savingComment"
                                        @click="saveComment"
                                    >
                                        Modificar comentario
                                    </v-btn>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="mb-4 row align-items-center">
                                <label class="form-label-title col-sm-2 mb-0">Has attachments</label>
                                <div class="col-sm-10">
                                    <v-text-field :model-value="attachments.length > 0 ? 'Yes' : 'No'" readonly></v-text-field>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="imageAttachments.length > 0">
                            <div class="mb-4 row align-items-start">
                                <label class="form-label-title col-sm-2 mb-0">Attached images</label>
                                <div class="col-sm-10">
                                    <div class="attachments-grid">
                                        <v-card v-for="media in imageAttachments" :key="media.id || media.name" class="attachment-card">
                                            <v-btn
                                                class="attachment-delete-btn"
                                                icon="mdi-close"
                                                size="small"
                                                color="error"
                                                @click.stop="confirmDeleteMedia(media)"
                                            ></v-btn>
                                            <div @click="openMediaPreview(media)">
                                                <v-img :src="resolveMediaSrc(media)" :alt="media.alt || media.name || 'Comment image'" height="180" cover></v-img>
                                                <div class="attachment-name">{{ media.name || 'image' }}</div>
                                            </div>
                                        </v-card>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" v-if="videoAttachments.length > 0">
                            <div class="mb-4 row align-items-start">
                                <label class="form-label-title col-sm-2 mb-0">Attached videos</label>
                                <div class="col-sm-10">
                                    <div class="attachments-grid">
                                        <v-card v-for="media in videoAttachments" :key="media.id || media.name" class="attachment-card">
                                            <v-btn
                                                class="attachment-delete-btn"
                                                icon="mdi-close"
                                                size="small"
                                                color="error"
                                                @click.stop="confirmDeleteMedia(media)"
                                            ></v-btn>
                                            <div @click="openMediaPreview(media)">
                                                <video
                                                    :src="resolveMediaSrc(media)"
                                                    class="attachment-video"
                                                    muted
                                                    playsinline
                                                    preload="metadata"
                                                ></video>
                                                <div class="attachment-name">{{ media.name || 'video' }}</div>
                                            </div>
                                        </v-card>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <v-alert v-if="messageError !== ''" :type="typeOfMessage" :text="messageError"></v-alert>
                    </v-form>

                    <v-dialog v-model="dialogDeleteMedia" max-width="600px">
                        <v-card>
                            <v-card-title class="confirmation-dialog" primary-title>Confirmation</v-card-title>
                            <v-card-text>Are you sure you want to delete this attachment?</v-card-text>
                            <v-card-actions>
                                <v-btn color="red" text @click="dialogDeleteMedia = false">Cancel</v-btn>
                                <v-btn color="green" text :loading="deletingMedia" @click="deleteMedia()">Delete</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                    <v-dialog v-model="previewDialog" max-width="980px">
                        <v-card>
                            <v-card-title class="d-flex justify-space-between align-center">
                                <span>{{ previewImageAlt || previewImageName || 'Comment image' }}</span>
                            </v-card-title>
                            <v-card-text>
                                <video
                                    v-if="previewIsVideo"
                                    :src="previewImageSrc"
                                    controls
                                    autoplay
                                    playsinline
                                    style="width: 100%; max-height: 78vh; background: #000;"
                                ></video>
                                <v-img v-else :src="previewImageSrc" :alt="previewImageAlt || previewImageName || 'Comment image'" max-height="78vh" contain></v-img>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" variant="text" @click="previewDialog = false">Close</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArticleCommentStatusComponent from '@/components/article_comments/articleCommentStatusComponent.vue'
import {
    getArticleCommentDetailsService,
    articleCommmentsStatusChangeService,
    getArticleCommmentsStatusListService,
    updateArticleCommentService,
    updateArticleCommentDatesService,
    deleteArticleCommentMediaService
} from '@/services/ArticleCommentService'

export default {
    title: 'Product Comment Information',
    components: {
        ArticleCommentStatusComponent
    },
    data() {
        return {
            apiBase: process.env.VUE_APP_URL_API_BASE,
            commentData: {},
            attachments: [],
            previewDialog: false,
            previewImageSrc: '',
            previewImageAlt: '',
            previewImageName: '',
            previewIsVideo: false,
            approving: false,
            savingComment: false,
            savingDates: false,
            dialogDeleteMedia: false,
            itemMediaToDelete: null,
            deletingMedia: false,
            editableCreatedAt: '',
            editableUpdatedAt: '',
            statusSaving: false,
            statusSaved: false,
            statusOptions: [],
            selectedStatus: { id: 2, name: 'Pendiente' },
            editableComment: '',
            messageError: '',
            typeOfMessage: 'error'
        }
    },
    computed: {
        selectedStatusItem() {
            return {
                status_id: this.selectedStatus?.id || this.commentData?.status?.id || this.commentData?.status_id
            }
        },
        productName() {
            const articleName = this.commentData?.article?.name || this.commentData?.article_name
            if (!articleName) return '-'
            if (typeof articleName === 'string') return articleName
            return articleName.es || articleName.en || articleName.fr || '-'
        },
        isAlreadyApproved() {
            const statusName = this.commentData?.status?.name || this.commentData?.status_name || ''
            return statusName === 'Aprobado'
        },
        imageAttachments() {
            return this.attachments.filter((item) => !item.type || item.type === 'image')
        },
        videoAttachments() {
            return this.attachments.filter((item) => item.type === 'video')
        }
    },
    methods: {
        toDatetimeLocal(value) {
            if (!value) return ''

            let dateValue = value
            if (typeof value === 'object') {
                if (typeof value.timestamp === 'number') {
                    dateValue = value.timestamp * 1000
                } else if (value.date) {
                    dateValue = value.date
                }
            }

            const date = new Date(dateValue)
            if (Number.isNaN(date.getTime())) return ''

            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            const hours = String(date.getHours()).padStart(2, '0')
            const minutes = String(date.getMinutes()).padStart(2, '0')

            return `${year}-${month}-${day}T${hours}:${minutes}`
        },
        resolveMediaSrc(media) {
            if (!media) return ''
            if (media.path && media.name) {
                if (media.path.startsWith('http://') || media.path.startsWith('https://')) {
                    return `${media.path}${media.name}`
                }
                return `${this.apiBase}${media.path}${media.name}`
            }
            if (media.name) {
                return `${this.apiBase}/assets/article_comments/${media.name}`
            }
            return ''
        },
        openMediaPreview(media) {
            this.previewImageSrc = this.resolveMediaSrc(media)
            this.previewImageAlt = media?.alt || ''
            this.previewImageName = media?.name || ''
            this.previewIsVideo = media?.type === 'video'
            this.previewDialog = true
        },
        async changeCommentStatus(newStatus) {
            if (!this.commentData?.id || !newStatus?.id) return

            this.statusSaved = false
            try {
                this.statusSaving = true
                await articleCommmentsStatusChangeService(this.commentData.id, newStatus.id)
                this.selectedStatus = newStatus
                if (this.commentData.status) {
                    this.commentData.status.id = newStatus.id
                    this.commentData.status.name = newStatus.name
                }
                this.commentData.status_id = newStatus.id
                this.commentData.status_name = newStatus.name
                this.messageError = 'Estado actualizado correctamente.'
                this.typeOfMessage = 'success'
                this.statusSaved = true
                setTimeout(() => (this.statusSaved = false), 1500)
            } catch (error) {
                this.messageError = 'Error! No se pudo cambiar el estado del comentario.'
                this.typeOfMessage = 'error'
            } finally {
                this.statusSaving = false
                setTimeout(() => (this.messageError = ''), 6000)
            }
        },
        async approveComment() {
            if (!this.commentData?.id || this.isAlreadyApproved) return

            const approvedStatus = this.statusOptions.find((status) => status.name === 'Aprobado')
            if (!approvedStatus) {
                this.messageError = 'Error! No existe el estado Aprobado.'
                this.typeOfMessage = 'error'
                return
            }

            try {
                this.approving = true
                await this.changeCommentStatus(approvedStatus)
            } catch (error) {
                this.messageError = 'Error! No se pudo aprobar el comentario.'
                this.typeOfMessage = 'error'
            } finally {
                this.approving = false
                setTimeout(() => (this.messageError = ''), 6000)
            }
        },
        async saveComment() {
            if (!this.commentData?.id) return

            const text = (this.editableComment || '').trim()
            if (text === '') {
                this.messageError = 'Error! El comentario no puede estar vacío.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 6000)
                return
            }

            try {
                this.savingComment = true
                const response = await updateArticleCommentService(this.commentData.id, text)
                if (response.error) {
                    this.messageError = response.message || 'Error! No se pudo guardar el comentario.'
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.message || 'Comentario actualizado correctamente.'
                    this.typeOfMessage = 'success'
                    await this.getCommentDetails()
                }
            } catch (error) {
                this.messageError = 'Error! No se pudo guardar el comentario.'
                this.typeOfMessage = 'error'
            } finally {
                this.savingComment = false
                setTimeout(() => (this.messageError = ''), 6000)
            }
        },
        async saveDates() {
            if (!this.commentData?.id) return

            if (!this.editableCreatedAt && !this.editableUpdatedAt) {
                this.messageError = 'Error! Debes indicar al menos una fecha.'
                this.typeOfMessage = 'error'
                setTimeout(() => (this.messageError = ''), 6000)
                return
            }

            try {
                this.savingDates = true
                const response = await updateArticleCommentDatesService(
                    this.commentData.id,
                    this.editableCreatedAt,
                    this.editableUpdatedAt
                )
                if (response.error) {
                    this.messageError = response.message || 'Error! No se pudieron guardar las fechas.'
                    this.typeOfMessage = 'error'
                } else {
                    this.messageError = response.message || 'Fechas actualizadas correctamente.'
                    this.typeOfMessage = 'success'
                    await this.getCommentDetails()
                }
            } catch (error) {
                this.messageError = 'Error! No se pudieron guardar las fechas.'
                this.typeOfMessage = 'error'
            } finally {
                this.savingDates = false
                setTimeout(() => (this.messageError = ''), 6000)
            }
        },
        confirmDeleteMedia(media) {
            this.itemMediaToDelete = media
            this.dialogDeleteMedia = true
        },
        async deleteMedia() {
            if (!this.itemMediaToDelete || !this.itemMediaToDelete.id) {
                this.dialogDeleteMedia = false
                return
            }

            try {
                this.deletingMedia = true
                const response = await deleteArticleCommentMediaService(this.itemMediaToDelete.id)
                if (response.error) {
                    this.messageError = response.message || 'Error! No se pudo eliminar el archivo.'
                    this.typeOfMessage = 'error'
                } else {
                    this.attachments = this.attachments.filter((item) => item.id !== this.itemMediaToDelete.id)
                    this.messageError = response.message || 'Archivo eliminado correctamente.'
                    this.typeOfMessage = 'success'
                }
            } catch (error) {
                this.messageError = 'Error! No se pudo eliminar el archivo.'
                this.typeOfMessage = 'error'
            } finally {
                this.deletingMedia = false
                this.dialogDeleteMedia = false
                this.itemMediaToDelete = null
                setTimeout(() => (this.messageError = ''), 6000)
            }
        },
        async getCommentDetails() {
            try {
                const id = this.$route.params.id
                const data = await getArticleCommentDetailsService(id)
                this.commentData = data || {}
                this.editableComment = this.commentData.comment || ''
                this.editableCreatedAt = this.toDatetimeLocal(this.commentData.createdAt ?? this.commentData.created_at)
                this.editableUpdatedAt = this.toDatetimeLocal(this.commentData.updatedAt ?? this.commentData.updated_at)
                const statusId = this.commentData?.status?.id || this.commentData?.status_id
                const statusName = this.commentData?.status?.name || this.commentData?.status_name
                this.selectedStatus = this.statusOptions.find((status) => status.id === statusId)
                    || this.statusOptions.find((status) => status.name === statusName)
                    || { id: 2, name: 'Pendiente' }
                const multimedia = Array.isArray(this.commentData.multimedia) ? this.commentData.multimedia : []
                this.attachments = multimedia.filter((item) => !item.type || item.type === 'image' || item.type === 'video')
            } catch (error) {
                this.messageError = 'Error! No se pudo cargar el detalle del comentario.'
                this.typeOfMessage = 'error'
            }
        }
    },
    async beforeMount() {
        this.statusOptions = await getArticleCommmentsStatusListService()
        await this.getCommentDetails()
    }
}
</script>

<style lang="scss" scoped>
.attachments-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
    gap: 12px;
}

.attachment-card {
    position: relative;
    overflow: hidden;
    cursor: pointer;
}

.attachment-delete-btn {
    position: absolute;
    top: 4px;
    right: 4px;
    z-index: 1;
}

.attachment-name {
    padding: 8px;
    font-size: 12px;
    text-align: center;
    word-break: break-word;
}

.attachment-video {
    width: 100%;
    height: 180px;
    object-fit: cover;
    background: #000;
    display: block;
}
</style>